export const ChevronLineIcon: React.FC<{
  className?: string;
  color?: string;
}> = ({ className, color }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "#9a958f"}
    strokeWidth={2.2}
    strokeLinecap="round"
    className={className}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);
